import React, {Component} from 'react';
import moment from 'moment';


import './AppointmentView.css';
import Appointment from '../../api/Appointment';
import { FormLabeledItem, Button } from '../../components/FormUI';
import DateHelper from '../../components/DateHelper';
import Clinic from '../../api/Clinic';
import BiopedModal, { CardModal, ActionModal, SideModal } from '../../components/BioPedModal';
import NewAppForm from './forms/NewAppForm';

import Icon from '../../components/Icon';
import NoShow from '../NoShow';
import UserAppHistoryView from '../UserAppHistoryView';
import User from '../../api/User';
import AppointmentService from '../../api/services/AppointmentService';
import UserDetails, { DetailCard } from '../Clients/UserDetails';
import UserForm from '../Clients/forms/UserForm';
import RootModal from '../../components/RootModal';


export default class AppointmentView extends Component{
	constructor(props){
		super(props);
		this.state = {};
		this.dateHelper = new DateHelper();
		this.openEditor = this.openEditor.bind(this);
		this.onEditComplete = this.onEditComplete.bind(this);
		this.deleteApp = this.deleteApp.bind(this);
		this.handleShowHistory = this.handleShowHistory.bind(this);
		this.closeEditor = this.closeEditor.bind(this);

	}

	openEditor(){
		this.setState({editorOpen:true});
	}

	onEditComplete(app){
		this.setState({editorOpen:false});
		if(this.props.onSave){
			this.props.onSave(app);
		}
	}

	deleteApp(){

		const deleteModal = (
			<div className="delete-app button-modal">
				<div className="modal-caption">Are you sure you want to delete this appointment?</div>
				<div className="table hmax layout-fixed button-bar">
					<div>
						<div>
							<Button className="red" caption="Yes" onClick={() => {
								let appSer = new AppointmentService();
								appSer.delete(this.props.appointment.appointmentId).then((d) => {
									if(this.props.onSave){
										this.props.onSave(d);
									}
								})

								RootModal.CloseModal();
							}} />
						</div>
						<div>
							<Button caption="No" onClick={() => {
								RootModal.CloseModal()
							}} />
						</div>
					</div>
				</div>
			</div>
		)

		const modalId = RootModal.ShowModal(deleteModal);

		/*let appSer = new AppointmentService();
		appSer.delete(this.props.appointment.appointmentId).then((d) => {
			if(this.props.onSave){
				this.props.onSave(d);
			}
		})*/
	}

	handleShowHistory(){
		this.setState({side:<UserAppHistoryView user={new User(this.props.appointment.client)} requestClose={()=>this.setState({side:null})} />});
	}

	closeEditor(){
		this.setState({editorOpen:false})
	}

	showUserDetails = ()=>{
		this.setState({showDetails:true})
	}

	handleEdit = () =>{
		this.setState({showEdit:true, showDetails:false});
	}

	render(){
		if(this.props.appointment == null)return null;
		let app = new Appointment(this.props.appointment);
		let client = app.client;
		let clinic = new Clinic(app.clinicId);

		if(!this.props.isOpen){
			this.state.side = null;
		}

		console.log("Appointment View:", this.props.appointment, "  App:", app);

		/*let title = <div className="modal-title" style={{backgroundColor:'#' + app.appointmentType.color}}>
						{app.appointmentType.name} - {app.status}
						<div className="table align-middle align-center edit-btn" onClick={this.openEditor} style={{backgroundColor:'#' + app.appointmentType.color}}>
							<div>
								<div><Icon icon='edit' /></div>
							</div>
						</div>
					</div>;*/
		return (
			<CardModal className='app-view-modal' title={app.appointmentType.name + ' - ' + app.status} isOpen={this.props.isOpen} color={'#' + app.appointmentType.color} onActionClick={this.openEditor} actionIcon='edit' side={this.state.side} {...this.props} >
				<div className="appointment-view">
					<FormLabeledItem label="Client">
						<div className="client-name"><span title='View Details' onClick={this.showUserDetails}>{app.client.fullName}</span></div>
						<div className="table hmax">
							<div>
								<div>{client.homePhone ? "H: " + client.homePhone : ''}</div>
								<div className="align-right">{client.email ? "E: " + client.email : ''}</div>
							</div>
						</div>
					</FormLabeledItem>
					<FormLabeledItem label='Service'>
						{app.appointmentType.name}
					</FormLabeledItem>
					<div className="table hmax layout-fixed">
						<div>
							<div>
								<FormLabeledItem label='Date'>
									{moment(app.start).format('ddd MMM D, YYYY')}
								</FormLabeledItem>
							</div>
							<div>
								<FormLabeledItem label='Time'>
									{DateHelper.FormatTime(app.start)} - {DateHelper.FormatTime(app.end)}
								</FormLabeledItem>
							</div>
						</div>
						<div>
							<div>
								<FormLabeledItem label='Pedorthist'>
									{clinic.getDoctor(app.userId).fullName}
								</FormLabeledItem>
							</div>
							<div>
								<FormLabeledItem label='Status'>
									{app.status}
								</FormLabeledItem>
							</div>
						</div>
					</div>
					<FormLabeledItem label="Notes">
						<div className="comment"><pre>{app.comment}</pre></div>
					</FormLabeledItem>
					<div className="table hmax layout-fixed button-bar">
						<div>
							<div><Button caption="View History" onClick={this.handleShowHistory} /></div>
							<div><Button caption="Delete" onClick={this.deleteApp} /></div>
						</div>
					</div>
				</div>


				<ActionModal title="Appointment - Edit" close='Cancel' isOpen={this.state.editorOpen} onRequestClose={this.closeEditor}>
					<NewAppForm appointment={this.props.appointment} clinicId={app.clinicId} doctorId={app.userId} onSave={this.onEditComplete} />
				</ActionModal>
				{/*<BiopedModal isOpen={this.state.showDetails} onRequestClose={() => this.setState({showDetails:false})}>
                    <DetailCard user={client} onBack={() => this.setState({showDetails:false})} />
                </BiopedModal>*/}

				<BiopedModal isOpen={this.state.showDetails} onRequestClose={() => this.setState({showDetails:false})}>
					<UserDetails hideEdit={this.props.hideEdit} user={client} backCaption='Close' onBack={() => this.setState({showDetails:false})} onEdit={this.handleEdit} />
				</BiopedModal>
				<ActionModal close='Close' title='Edit Patient' className='scrollable' isOpen={this.state.showEdit} onRequestClose={() => this.setState({showEdit:false})}>
					<UserForm className='popup-form' user={client} onBack={() => this.setState({showEdit:false})} />
				</ActionModal>


			</CardModal>
		)
	}
}



// WEBPACK FOOTER //
// ./src/views/Appointments/AppointmentView.js